import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  @ViewChild('panel',{static:true}) panel: OverlayPanel;

  constructor() { }

  ngOnInit(): void {
  }
  
  toggle(event : Event){
    debugger;
    this.panel.toggle(event);
  }

}
